module.exports = __webpack_public_path__ + "static/media/01_A1_102.b045c631.png";